module.exports = __webpack_public_path__ + "media/oceans_call.5a3d6ddd.webm";